import React from "react"
import Typography from '@mui/material/Typography';


export const SourcesMono = () => {

return(
<div>
<br /><br />
<Typography component="span" variant="h5" sx={{fontWeight: '700'}}>Sources: </Typography>
 <br /><br />

https://www.nature.com/articles/s41576-021-00414-z<br />    
https://pubmed.ncbi.nlm.nih.gov/29484031/<br /> 
https://pubmed.ncbi.nlm.nih.gov/22891219/<br /> 
</div>
)
}